import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'via-feedback-flag',
  templateUrl: './feedback-flag.component.html',
  styleUrls: ['./feedback-flag.component.scss']
})
export class FeedbackFlagComponent {

  @Input()
  public feedbackReviewPending: boolean;

  @Output()
  public submitFeedback = new EventEmitter<Event>();

  public feedbackTooltipText = 'Indicates if feedback given on the SKU is currently being reviewed. A clear flag indicates no feedback or review has been completed, while an orange flag indicates feedback has been submitted or a review is in progress.';

  public onSubmitFeedback($event: Event): void {
    this.submitFeedback.emit($event);
  }

}
